<template>

  <div class="col-md-4 borderRight mb-2">
    <h3>Класс(ы)</h3>
    <div v-if="!selectedAction.id">
      <button type="button" class="btn btn-success myBtnStyle fz10 cursor" @click="updateProductModal(true)"
              :disabled="!currentChoosenNode.parent_id">Добавить Класс
      </button>
      <button type="button" class="btn btn-warning myBtnStyle fz10 cursor ml-1" @click="getProduct()">Изменить
      </button>
      <button type="button" class="btn btn-danger myBtnStyle fz10 cursor ml-1" @click="deleteProduct()">Удалить
      </button>
      <button type="button" class="btn btn-info myBtnStyle fz10 cursor ml-1" v-b-toggle="'findProductBlock'">
        Поиск
      </button>
    </div>
    <div v-else>

      <button type="button" class="btn btn-danger myBtnStyle fz10 cursor ml-1"
              @click="updateShowProduct({visible:true})">показать действие
      </button>
    </div>
    <div class="d-flex justify-content-between mb10" v-for="(product, index) in categoryProducts" :key="index">
      <div class="left">
        <a class="cursor titleHover" v-if="DISPLAY_PRODUCT_ID==='id'"
           :class="{highlight:product.id === selectedProduct.id, 'bg-danger': product.state === 'I', 'bg-warning': product.state !== 'A' && product.state !== 'I'}"
           @click="productClick(product)">{{ product.id }}
          {{ product.title }}</a>
        <a class="cursor titleHover" v-if="DISPLAY_PRODUCT_ID==='code'"
           :class="{highlight:product.id === selectedProduct.id, 'bg-danger': product.state === 'I', 'bg-warning': product.state !== 'A' && product.state !== 'I'}"
           @click="productClick(product)">{{ product.code }}
          {{ product.title }}</a>
      </div>
      <div class="right">
        <span v-if="!product.fields_count">[0]</span>
        <span class="text-success" v-else>[{{ product.fields_count }}]</span>
      </div>
    </div>
    <notValidatedActions
        :notValidatedActions="notValidatedActions"
        :selectedAction="selectedAction"
        @actionClick="actionClick"
    ></notValidatedActions>

    <ProductStore
        :product="product"
        :showProductModal="showProductModal"
        :units="units"
        @update="updateProductModal">

    </ProductStore>

    <ProductEdit
        :productEdit="productEdit"
        v-show="showProductEditModal"
        :languages="languages"
        :units="units"
        @update="updateProductEditModal">

    </ProductEdit>


    <ProductWatch
        :product="selectedProduct"
        :showProductWatchModal="showProductWatchModal"
        :units="units"
        @update="updateShowProduct">

    </ProductWatch>
  </div>
</template>

<script>

import ProductStore from "@/views/allLogic/modals/product/store";
import ProductEdit from "@/views/allLogic/modals/product/productEdit";
import ProductWatch from "@/views/allLogic/modals/product/watch"
import {DELETE, GET} from "@/shared/api";
import notValidatedActions from "@/views/allLogic/common/notValidatedActions";

export default {
  components: {ProductStore, ProductEdit, ProductWatch, notValidatedActions},
  props: {
    currentChoosenNode: {
      id: null
    },
    languages: [],
    units: [],
  },
  data() {
    return {
      categoryProducts: [],
      category: {
        parent_id: 0,
        code: null,
        ru_title: ""
      },
      selectedProduct: {
        id: null,
        duplicateCategoryId: null
      },
      productEdit: {},
      showProductWatchModal: false,
      showProductModal: false,
      showProductEditModal: false,
      product: {},

      notValidatedActions: [],
      selectedAction: {
        id: null,
      },
    }
  },
  watch: {
    currentChoosenNode: {
      handler: "categoryChange"
    }
  },
  methods: {
    updateShowProduct(state) {
      if (typeof state === 'object' && typeof state.visible === 'boolean') {
        this.showProductWatchModal = state.visible;
        if (this.showProductWatchModal === true) {
          switch (this.selectedAction.secondShortRoute) {
            case "destroy":
              this.getProduct(this.selectedAction.request_data.id);
              break;
            default:
              this.selectedProduct = this.selectedAction.request_data.request;
              if (this.selectedProduct.translations) {
                this.selectedProduct.translations.forEach((el) => {
                  if (el.locale && el.locale === 'ru') {
                    el.title = this.selectedProduct.title;
                  }
                });
              }
              if (this.selectedProduct.title == null && typeof this.selectedProduct.ru_title == "string") {
                this.selectedProduct.title = this.selectedProduct.ru_title;
              }
          }
        }
      }

    },
    categoryChange(newer, older) {
      this.getCategoryProducts();
      this.getCategoryActions();
      this.selectedAction = {
        id: null,
      };

    },

    getCategoryProducts() {
      if (this.currentChoosenNode.id) {
        GET([], "/category/query/" + this.currentChoosenNode.id + "?mode=products", this, false).then(response => {
          this.categoryProducts = response;
        });
      }
    },

    getCategoryActions() {
      if (this.currentChoosenNode.id) {
        GET([], "/category/query/" + this.currentChoosenNode.id + "?mode=product_actions", this, false).then(response => {
          let result = response;

          result.forEach((val, index) => {
            val.request_data = JSON.parse(val.request_data);
            val.route = JSON.parse(val.route);
            if (typeof val.user == 'undefined' || val.user == null) {
              val.user = {
                name: null
              }
            }

            if (typeof val.action === 'undefined' || val.action === null) {
              val.action = {
                action: null,
                user: {
                  name: null
                }
              }
            }
          });
          this.notValidatedActions = result;
        });
      }
    },

    updateCol(event, state) {
      this.$emit(event, state);
    },
    getProduct(id = null) {
      let wasNull = false;
      if (id === null) {
        id = this.clickedProductId;
        wasNull = true;
      }
      GET({with: []}, "/product/" + id, this, false).then(response => {
        if (wasNull === true) {
          this.productEdit = response;
          this.updateProductEditModal(true);
        } else {
          this.selectedProduct = response;
        }
      });
    },
    deleteProduct() {
      DELETE(this.clickedProductId, "/product/", this).then(response => {
        this.getCategoryProducts()
      });
    },
    actionClick(obj) {
      this.selectedAction = obj.action;
      this.selectedAction.index = obj.index;
      this.productClick({
        id: null,
        duplicateCategoryId: null
      })
    },
    productClick(product) {
      if (product.id !== null) {
        this.selectedAction = {id: null}
      }
      this.selectedProduct = product;
      this.clickedProductId = product.id;
      this.updateCol('update', {
        action: "clicked",
        clickedProductId: this.clickedProductId,
        selectedProduct: this.selectedProduct
      });
    },
    updateProductModal(state = false) {
      if (typeof state === "object" && state.state === "success") {
        this.categoryProducts = [];
        this.getCategoryProducts()
        this.getCategoryActions();
        this.showProductModal = false;

      } else {
        if (state) {
          this.product.category_id = this.currentChoosenNode.id;
          this.product.ru_title = this.currentChoosenNode.title;
          this.product.code = this.currentChoosenNode.code;
          this.product.unit_id = this.units[0]['id'];
          this.showProductModal = state;
        } else {
          this.showProductModal = state;
        }
      }
    },
    updateProductEditModal(state = true) {
      if (typeof state === "object" && state.state === "success") {
        this.showProductEditModal = false;
        this.getCategoryProducts()
        this.getCategoryActions();
      }
      if (typeof state === 'boolean') {
        this.showProductEditModal = state;
      }
    },
    clearProduct() {
      this.product.ru_title = null;
      this.product.version = null;
      this.product.unit = null;
      this.product.code = null;
      this.product.category_id = null;
    },
  }, mounted() {
    // console.log(this.categoryProducts)
  }
}
</script>

<style scoped>

</style>
